import { utils, Contract } from 'ethers';

/* Autogenerated file. Do not edit manually. */
var _abi = [{
  type: "event",
  anonymous: false,
  name: "LogProposalApprove",
  inputs: [{
    type: "string",
    name: "name",
    indexed: false
  }, {
    type: "address",
    name: "tokenAddress",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "LogProposalImported",
  inputs: [{
    type: "string",
    name: "name",
    indexed: false
  }, {
    type: "string",
    name: "symbol",
    indexed: false
  }, {
    type: "address",
    name: "proposer",
    indexed: false
  }, {
    type: "bytes32",
    name: "hashIndex",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "LogProposalReferralSubmit",
  inputs: [{
    type: "address",
    name: "referral",
    indexed: false
  }, {
    type: "uint8",
    name: "referralPercentage",
    indexed: false
  }, {
    type: "bytes32",
    name: "hashIndex",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "LogProposalSubmit",
  inputs: [{
    type: "string",
    name: "name",
    indexed: false
  }, {
    type: "string",
    name: "symbol",
    indexed: false
  }, {
    type: "address",
    name: "proposer",
    indexed: false
  }, {
    type: "bytes32",
    name: "hashIndex",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "OwnershipTransferred",
  inputs: [{
    type: "address",
    name: "previousOwner",
    indexed: true
  }, {
    type: "address",
    name: "newOwner",
    indexed: true
  }]
}, {
  type: "function",
  name: "approveProposal",
  constant: false,
  payable: false,
  inputs: [{
    type: "bytes32",
    name: "_hashIndex"
  }, {
    type: "address",
    name: "_token"
  }],
  outputs: [{
    type: "bool"
  }]
}, {
  type: "function",
  name: "creatorReferral",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "bytes32"
  }],
  outputs: [{
    type: "address",
    name: "referral"
  }, {
    type: "uint8",
    name: "referralPercentage"
  }]
}, {
  type: "function",
  name: "getCreatorByIndex",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "bytes32",
    name: "_hashIndex"
  }],
  outputs: [{
    type: "tuple",
    components: [{
      type: "address",
      name: "token"
    }, {
      type: "string",
      name: "name"
    }, {
      type: "string",
      name: "symbol"
    }, {
      type: "uint256",
      name: "totalSupply"
    }, {
      type: "uint256",
      name: "vestingPeriodInDays"
    }, {
      type: "address",
      name: "proposer"
    }, {
      type: "address",
      name: "vestingBeneficiary"
    }, {
      type: "uint8",
      name: "initialPlatformPercentage"
    }, {
      type: "uint8",
      name: "decimals"
    }, {
      type: "uint8",
      name: "initialPercentage"
    }, {
      type: "bool",
      name: "approved"
    }]
  }]
}, {
  type: "function",
  name: "getCreatorByName",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "string",
    name: "_name"
  }],
  outputs: [{
    type: "tuple",
    components: [{
      type: "address",
      name: "token"
    }, {
      type: "string",
      name: "name"
    }, {
      type: "string",
      name: "symbol"
    }, {
      type: "uint256",
      name: "totalSupply"
    }, {
      type: "uint256",
      name: "vestingPeriodInDays"
    }, {
      type: "address",
      name: "proposer"
    }, {
      type: "address",
      name: "vestingBeneficiary"
    }, {
      type: "uint8",
      name: "initialPlatformPercentage"
    }, {
      type: "uint8",
      name: "decimals"
    }, {
      type: "uint8",
      name: "initialPercentage"
    }, {
      type: "bool",
      name: "approved"
    }]
  }]
}, {
  type: "function",
  name: "getCreatorBySymbol",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "string",
    name: "_symbol"
  }],
  outputs: [{
    type: "tuple",
    components: [{
      type: "address",
      name: "token"
    }, {
      type: "string",
      name: "name"
    }, {
      type: "string",
      name: "symbol"
    }, {
      type: "uint256",
      name: "totalSupply"
    }, {
      type: "uint256",
      name: "vestingPeriodInDays"
    }, {
      type: "address",
      name: "proposer"
    }, {
      type: "address",
      name: "vestingBeneficiary"
    }, {
      type: "uint8",
      name: "initialPlatformPercentage"
    }, {
      type: "uint8",
      name: "decimals"
    }, {
      type: "uint8",
      name: "initialPercentage"
    }, {
      type: "bool",
      name: "approved"
    }]
  }]
}, {
  type: "function",
  name: "getCreatorReferralByIndex",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "bytes32",
    name: "_hashIndex"
  }],
  outputs: [{
    type: "tuple",
    components: [{
      type: "address",
      name: "referral"
    }, {
      type: "uint8",
      name: "referralPercentage"
    }]
  }]
}, {
  type: "function",
  name: "getIndexByName",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "string",
    name: "_name"
  }],
  outputs: [{
    type: "bytes32"
  }]
}, {
  type: "function",
  name: "getIndexBySymbol",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "string",
    name: "_symbol"
  }],
  outputs: [{
    type: "bytes32"
  }]
}, {
  type: "function",
  name: "importByIndex",
  constant: false,
  payable: false,
  inputs: [{
    type: "bytes32",
    name: "_hashIndex"
  }, {
    type: "address",
    name: "_oldRegistry"
  }],
  outputs: []
}, {
  type: "function",
  name: "initialize",
  constant: false,
  payable: false,
  inputs: [],
  outputs: []
}, {
  type: "function",
  name: "legacyProposals",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "string",
    name: "_name"
  }],
  outputs: [{
    type: "tuple",
    components: [{
      type: "address",
      name: "token"
    }, {
      type: "string",
      name: "name"
    }, {
      type: "string",
      name: "symbol"
    }, {
      type: "uint256",
      name: "totalSupply"
    }, {
      type: "uint256",
      name: "vestingPeriodInDays"
    }, {
      type: "address",
      name: "proposer"
    }, {
      type: "address",
      name: "vestingBeneficiary"
    }, {
      type: "uint8",
      name: "initialPlatformPercentage"
    }, {
      type: "uint8",
      name: "decimals"
    }, {
      type: "uint8",
      name: "initialPercentage"
    }, {
      type: "bool",
      name: "approved"
    }]
  }]
}, {
  type: "function",
  name: "legacyProposalsByIndex",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "bytes32",
    name: "hashIndex"
  }],
  outputs: [{
    type: "tuple",
    components: [{
      type: "address",
      name: "token"
    }, {
      type: "string",
      name: "name"
    }, {
      type: "string",
      name: "symbol"
    }, {
      type: "uint256",
      name: "totalSupply"
    }, {
      type: "uint256",
      name: "vestingPeriodInDays"
    }, {
      type: "address",
      name: "proposer"
    }, {
      type: "address",
      name: "vestingBeneficiary"
    }, {
      type: "uint8",
      name: "initialPlatformPercentage"
    }, {
      type: "uint8",
      name: "decimals"
    }, {
      type: "uint8",
      name: "initialPercentage"
    }, {
      type: "bool",
      name: "approved"
    }]
  }]
}, {
  type: "function",
  name: "owner",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "address"
  }]
}, {
  type: "function",
  name: "renounceOwnership",
  constant: false,
  payable: false,
  inputs: [],
  outputs: []
}, {
  type: "function",
  name: "rolodex",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [{
    type: "bytes32"
  }],
  outputs: [{
    type: "address",
    name: "token"
  }, {
    type: "string",
    name: "name"
  }, {
    type: "string",
    name: "symbol"
  }, {
    type: "uint256",
    name: "totalSupply"
  }, {
    type: "uint256",
    name: "vestingPeriodInDays"
  }, {
    type: "address",
    name: "proposer"
  }, {
    type: "address",
    name: "vestingBeneficiary"
  }, {
    type: "uint8",
    name: "initialPlatformPercentage"
  }, {
    type: "uint8",
    name: "decimals"
  }, {
    type: "uint8",
    name: "initialPercentage"
  }, {
    type: "bool",
    name: "approved"
  }]
}, {
  type: "function",
  name: "setLegacyRegistryAddress",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_legacyRegistry"
  }],
  outputs: []
}, {
  type: "function",
  name: "submitProposal",
  constant: false,
  payable: false,
  inputs: [{
    type: "string",
    name: "_name"
  }, {
    type: "string",
    name: "_symbol"
  }, {
    type: "uint8",
    name: "_decimals"
  }, {
    type: "uint256",
    name: "_totalSupply"
  }, {
    type: "uint8",
    name: "_initialPercentage"
  }, {
    type: "uint256",
    name: "_vestingPeriodInDays"
  }, {
    type: "address",
    name: "_vestingBeneficiary"
  }, {
    type: "address",
    name: "_proposer"
  }, {
    type: "uint8",
    name: "_initialPlatformPercentage"
  }],
  outputs: [{
    type: "bytes32",
    name: "hashIndex"
  }]
}, {
  type: "function",
  name: "submitProposalReferral",
  constant: false,
  payable: false,
  inputs: [{
    type: "bytes32",
    name: "_hashIndex"
  }, {
    type: "address",
    name: "_referral"
  }, {
    type: "uint8",
    name: "_referralPercentage"
  }],
  outputs: []
}, {
  type: "function",
  name: "transferOwnership",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "newOwner"
  }],
  outputs: []
}];
var Registry__factory = /** @class */function () {
  function Registry__factory() {}
  Registry__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  Registry__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  Registry__factory.abi = _abi;
  return Registry__factory;
}();

export { Registry__factory };
